/**
 * Cible désignée par le geste du joueur.
 *
 * La direction du glissé, prolongée jusqu'à une rangée, donne la colonne ; la force
 * du geste (longueur vers le haut + vitesse au lâcher) donne la rangée : un geste
 * doux s'arrête dans la rangée proche, un geste appuyé atteint la rangée lointaine.
 * Aucune cible n'est mise en avant pendant le geste : seul le lâcher compte.
 *
 * @param {{x:number,y:number}} start   point de départ du doigt (repère du plateau)
 * @param {{x:number,y:number}} end     point de lâcher
 * @param {{x0:number,y0:number,x1:number,y1:number}[]} rects cibles (repère du plateau)
 * @param {{x:number,y:number}} puck    centre du palet au repos
 * @param {number} speed                vitesse au lâcher (px/ms)
 * @returns {{index:number, point:{x:number,y:number}}|null}
 */
export function aimTarget(start, end, rects, puck, speed = 0) {
  const dx = end.x - start.x;
  const up = start.y - end.y;
  if (up < 12 && speed < 0.4) return null; // pas un lancer
  if (up <= 0 && Math.abs(dx) < 40) return null;

  const centers = rects.map((r) => ({ x: (r.x0 + r.x1) / 2, y: (r.y0 + r.y1) / 2, w: r.x1 - r.x0 }));
  const ys = [...new Set(centers.map((c) => Math.round(c.y)))].sort((a, b) => b - a); // proche d'abord
  // Force : longueur du geste vers le haut + élan au lâcher.
  const power = Math.max(up, 0) + 70 * speed;
  let row = 0;
  for (let r = 1; r < ys.length; r += 1) {
    if (power >= 160 * r) row = r; // même geste = même portée, quel que soit l'écran
  }
  const rowY = ys[row];

  // Direction : le geste prolongé jusqu'à la rangée (geste latéral borné).
  const slope = dx / Math.max(up, Math.hypot(dx, up) * 0.3, 1);
  const x = puck.x + slope * Math.max(puck.y - rowY, 1);
  let best = null;
  centers.forEach((c, i) => {
    if (Math.round(c.y) !== rowY) return;
    if (!best || Math.abs(c.x - x) < Math.abs(best.c.x - x)) best = { c, i };
  });
  // Le palet s'arrête sur la cible, décalé du côté où penchait le geste.
  const offset = Math.max(-0.22 * best.c.w, Math.min(0.22 * best.c.w, x - best.c.x));
  return { index: best.i, point: { x: best.c.x + offset, y: best.c.y } };
}
